// extracted by mini-css-extract-plugin
module.exports = {"authButtonsWrapper":"AuthNav_authButtonsWrapper__jmW3m"};